'use client';
import { __awaiter } from 'tslib';
import { useForageItem } from './useForageItem.js';

/**
 * each item in the array gets its own key
 * @param groupKey
 * @param isValid
 * @returns
 */
function useForageArray(groupKey, isValid, defaultValue = []) {
    const { isLoading, item: array, set: setArray } = useForageItem(groupKey, (arr) => Array.isArray(arr) && arr.every(isValid), defaultValue);
    function clear() {
        return __awaiter(this, void 0, void 0, function* () {
            yield setArray([]);
        });
    }
    function set(index, value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValid(value))
                throw new Error("invalid set value");
            yield setArray(array.map((x, i) => i === index ? value : x));
        });
    }
    function setEntire(value) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setArray(value);
        });
    }
    function add(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!isValid(value)) {
                console.log("invalid value", "key", groupKey);
                console.log(value);
                throw new Error("invalid set value");
            }
            yield setArray([...array, value]);
        });
    }
    function remove(index) {
        return __awaiter(this, void 0, void 0, function* () {
            yield setArray(array.filter((_, i) => i !== index));
        });
    }
    return {
        isLoading,
        set,
        clear,
        add,
        remove,
        items: array,
        setEntire
    };
}

export { useForageArray };
